module.exports = __webpack_public_path__ + "static/media/touhoulunanight.374abcf8.png";